/**
 * dev 도구(상황 패널·MSW mock) 활성 조건.
 *
 * DEV_TOOLS_ENABLED — 로컬 dev 또는 배포된 dev 호스트(`dev-*`)에서만 true.
 *   stg/prod 호스트에서는 false → 패널·MSW 가 동작하지 않는다.
 *
 * getMockMode — MSW mock 모드 on/off (runtime, localStorage). DevScenarioPanel 에서 토글.
 *   배포된 dev 는 기본 off(실서버 연결) — 시나리오 테스트 시에만 켠다.
 *   로컬 dev 는 VITE_USE_MOCK 을 기본값으로 따른다.
 */

export const DEV_TOOLS_ENABLED =
  import.meta.env.DEV || (typeof window !== 'undefined' && window.location.hostname.startsWith('dev-'))

const MOCK_MODE_KEY = 'dev-mock-mode'

export function getMockMode(): boolean {
  if (!DEV_TOOLS_ENABLED || typeof window === 'undefined') return false
  const stored = window.localStorage.getItem(MOCK_MODE_KEY)
  if (stored != null) return stored === 'true'
  return import.meta.env.DEV && import.meta.env.VITE_USE_MOCK === 'true'
}

export function setMockMode(enabled: boolean): void {
  window.localStorage.setItem(MOCK_MODE_KEY, String(enabled))
}
